import {GetTabgrade,GetItem} from "@/api"

const state = {
  theme:1,            //1：浅色；2：深色
  sysinfo:{},       // 系统信息
  itemlist:{},      // item列表的信息
  isTab1:0,         // 1级tab的选择， 0-全部，1-榜单，2-热门
  message_text:"提交成功，感谢反馈~",     // 消息文案
  message_bac:0,                        //  消息类型，0-成功，1-警告
  isShowMessage:false,                  //  消息是否展示
}

const mutations = {
  SET_THEME:(state,val)=>{
    state.theme = val
  },
  SET_SYSINFO:(state,val)=>{
    state.theme = val.theme
    state.sysinfo = val
    state.sysinfo.logo = process.env.VUE_APP_PIC_URL + val.logo
    state.sysinfo.pic404url = process.env.VUE_APP_PIC_URL + val.pic404url
    state.sysinfo.technology_qian = val.technology_qian.split(',')
    state.sysinfo.technology_hou = val.technology_hou.split(',')
  },
  SET_ITEMLIST:(state,val)=>{
    state.itemlist = val
  },
  SET_ISTAB1:(state,val)=>{
    state.isTab1 = val
  },
  SET_MESSAGE:(state,val)=>{
    switch(val){
      case 'succ':
        state.message_bac = 0
        state.message_text = "提交成功，感谢反馈~"
        state.isShowMessage = true
        break
      case 'warn':
        state.message_bac = 1
        state.message_text = "请输入内容再反馈~"
        state.isShowMessage = true
        break
      case 'close':
        state.isShowMessage = false
        break
    }
  }
}

const actions = {
  // 获取热门item
  getHopItem(context,param){
    GetItem(param).then(res=>{
        var list  
        list = res.records
        list.forEach(i => {
            i.picurl = process.env.VUE_APP_PIC_URL + i.picurl
            i.typelist = i.typelist.split('，')
        });
        context.commit('SET_ITEMLIST',list)
    }).catch()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
